export default [
    {
        path: '/warehouse',
        meta: {
            title: "Warehouse",
            icon: "inventory.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "warehouse" */ '../views/admin/page/Warehouse/Index'),
        redirect: { name: 'receivinggood' },
        children: [
            {
                path: 'receivinggood',
                name: 'receivinggood',
                meta: {
                    title: "Receiving Good",
                    show: true
                },
                component: () => import(/* webpackChunkName: "warehouse" */ '../views/admin/page/Warehouse/ReceivingGood'),
            },
            {
                path: 'receivinggood/:id',
                name: 'receivinggoodid',
                meta: {
                    title: "Receiving Good Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "warehouse" */ '../views/admin/page/Warehouse/ReceivingGoodDetail'),
            },
            {
                path: 'receivinggood/:id/:role',
                name: 'receivinggooddetail',
                meta: {
                    title: "Receiving Good Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "warehouse" */ '../views/admin/page/Warehouse/ReceivingGoodDetail'),
            }
        ]
    }
]